<script>
export default {
  name: "uni-filter",
  mounted() {
    console.log("inline template component");
  },
  data() {
    return {
      filter: {},
      priceRange: [2250, 10000],
    };
  },
  methods: {
    store() {},
  },
};
</script>
